<template lang="pug">
page(
    main-title="Финансы",
    main-description="Магазины, платежи, aналитика"
)
    .row
        .col-md-6
            button.btn.btn-default.margin-bottom-10(@click='changeCompany(15)') 
                | Перейти к нашим <b>демо</b> магазинам
    .row
        .col-md-6
            field(
                label="Поиск по имени, телефону, email, домену, CMS",
                :item="search",
            )

    PayingCompanies(:search="searchQuery")
    NotPayingCompanies(:search="searchQuery")
</template>

<script>
import debounce from 'lodash/debounce';
import { mapActions } from 'vuex';

import ajaxRequest from '@/utils/request';
import PayingCompanies from './PayingCompanies.vue';
import NotPayingCompanies from './NotPayingCompanies.vue';

export default {
    name: 'Finance',
    components: {PayingCompanies, NotPayingCompanies},
    methods: {
        ...mapActions(['changeCompany']),
        setSearchValue: debounce(function(value) { this.searchQuery = value; }, 1000)
    },
    watch: {
        'search.value'(value) {
            this.setSearchValue(value);
        }
    },
    data() {
        return {
            search: {
                value: '',
                valid: true
            },
            searchQuery: ''
        };
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/finance/Finance.vue